import { useEffect } from "react";
import { beep, buzz } from "../lib/device";
import { useKaya } from "../store/kayaStore";
import { I } from "./icons";

/** Celebrates one freshly unlocked badge at a time, draining the queue as they are dismissed. */
export function BadgeModal() {
  const { badgeQueue, dismissBadge, S } = useKaya();
  const b = badgeQueue[0];

  useEffect(() => {
    if (!b) return;
    beep(1318, 200, 0.15, S.profile.sound);
    buzz([80, 60, 160], S.profile.vibrate);
  }, [b, S.profile.sound, S.profile.vibrate]);

  if (!b) return null;

  return (
    <div className="modal" onClick={(e) => e.target === e.currentTarget && dismissBadge()}>
      <div className="box">
        <div className={`medal ${b.c || ""}`}>{b.e}</div>
        <div className="k">BADGE UNLOCKED</div>
        <h2>{b.n}</h2>
        <p>{b.d}</p>
        <button className="primary big" onClick={dismissBadge}>
          {I.check}Nice
        </button>
      </div>
    </div>
  );
}
